import { html, View } from 'rune-ts';
import klass from './RankView.module.scss';
import { classes } from '@services/MarppleShop/shared/util';
import { staticFont } from '@services/MarppleShop/shared/typography';

type TProps = {
  size: 'Large (Xlarge~Large)' | 'Medium (Medium~Small)';
  ranking: number;
};

/**
 * https://www.figma.com/design/J3pxvmlv167DXuLToyL3Mg/%EC%83%81%ED%92%88-%EC%B9%B4%EB%93%9C-UI?node-id=368-189900&m=dev
 */
export class RankView extends View<TProps> {
  protected override template({ ranking, size }: TProps) {
    return html`<span
      class="${classes(klass.rank, {
        [klass.size_large]: size === 'Large (Xlarge~Large)',
        [klass.size_medium]: size === 'Medium (Medium~Small)',
      })}"
    >
      <span
        class="${classes({
          [staticFont('bebas_16_bold')]: size === 'Large (Xlarge~Large)',
          [klass.visual_correction]: size === 'Medium (Medium~Small)',
          [staticFont('bebas_12_bold')]: size === 'Medium (Medium~Small)',
        })}"
      >
        ${ranking}
      </span>
    </span>`;
  }
}
